<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>商品介绍详情管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-rowl">
        <div class="select_add flex-rowl">
          <router-link
            :to="{
              path: `/commondityIndex/cManageEdit/cIntroDetailSet/${cmid}/1/0`,
            }"
            ><p class="flex-rowl">
              <i class="iconfont icon-xinzeng"></i> 新增
            </p></router-link
          >
        </div>
        <div class="select_edit flex-rowl" v-if="dataList.length > 0">
          <router-link
            :to="{
              path: `/commondityIndex/cManageEdit/cIntroDetailSet/${cmid}/0/0`,
            }"
            ><p class="flex-rowl">
              <i class="iconfont icon-edit"></i> 编辑全部
            </p></router-link
          >
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <!-- <div class="pic_box">
                  <el-image :src="item.img" fit="contain">
                    <div slot="error" class="image-slot flex-rowc">
                      <i class="iconfont icon-zanwutupian1"></i>
                    </div>
                  </el-image>
                </div> -->
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <h1>商品名称：</h1>
                    <p>
                      <span>{{ detail.commodityname }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>指定样式内容：</p>
                    <p v-if="item.conttype == 1"><span>图片</span></p>
                    <p v-if="item.conttype == 2"><span>视频</span></p>
                    <p v-if="item.conttype == 3"><span>文本</span></p>
                  </div>
                  <div class="block" v-if="item.conttype == 1">
                    <p>图片：</p>
                    <div class="video_box">
                      <img :src="item.picurl" alt="" />
                    </div>
                  </div>
                  <div class="block" v-if="item.conttype == 2">
                    <p>视频：</p>
                    <div class="video_box">
                      <video
                        :src="item.videourl"
                        controls
                        :poster="item.picurl"
                      ></video>
                    </div>
                  </div>
                  <div class="block" v-if="item.conttype == 3">
                    <p>详情内容：</p>
                    <p v-html="item.details"></p>
                  </div>
                </div>
                <!-- <div class="operation_box flex-colt">
                  <router-link
                    :to="'/commondityIndex/cManageEdit/cBaseinfo/' + item.id"
                    >基础信息设置</router-link
                  >
                </div> -->
                <div class="editBtn" @click="handleEdit(item.id)">
                  编辑详情→
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="暂无数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->
  </div>
</template>

<script>
import { getCommidityDetail } from "../../../api/api";
export default {
  name: "cIntroDetail",
  data() {
    return {
      cmid: "",
      loading: false,
      detail: "",
      dataList: [],
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.loading = true;
      let { id } = this.$route.params;
      this.cmid = id;
      getCommidityDetail({ id }).then((res) => {
        this.detail = res;
        this.dataList = res.details ? res.details : "";
        this.loading = false;
      });
    },

    handleEdit(id) {
      let cmid = this.$route.params.id;
      this.$router.push(
        `/commondityIndex/cManageEdit/cIntroDetailSet/${cmid}/0/${id}`
      );
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  .main_container {
    .list_wrap {
      height: 60vh;
    }
    .shop_list {
      .shop_more {
        height: 50px;
        border-top: 1px solid #fff;
      }
    }
    .video_box {
      // width: 100px;
      height: 200px;
      video,
      img {
        height: 100%;
      }
    }
  }
}
</style>